import React, {useRef, useState} from "react"
import * as Yup from "yup"
import {useSelector} from "react-redux"
import {useForm} from "react-hook-form"
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap"
import Switch from "react-bootstrap-switch";

// components
import Separator from "../../../components/Separator";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {GenericButton} from "../../../components/buttons/customButtons";
import SelectGeneric from "../../../components/select/selectGeneric";

// labels
import {
    PH_IMAGE,
    PH_LANDING_CODE,
    PH_SIVEX_CODE,
    PH_SIVEX_ID,
    PH_VERSION_IOS
} from "../../../components/i18n/placeHolders"
import {error, INTERNATIONAL, REQUIRED, selectOption} from "../../../components/i18n/i18n"
import {
    FL_CAT_PROD, FL_COMPONENT_ID, FL_IMAGE,
    FL_INCLUDE_FOOD, FL_INCLUDE_INFANTS,
    FL_IS_BASE_PRODUCT,
    FL_LANDING_CODE,
    FL_ORDER, FL_PARAM_C, FL_PARAM_D, FL_PARAM_P,
    FL_PARAM_T,
    FL_SIVEX_CODE,
    FL_SIVEX_ID,
    FL_STATUS, FL_TIPO_PROD, FL_VERSION_ANDROID, FL_VERSION_IOS
} from "../../../components/i18n/formLabels";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services

// utils
import {getStateByPath} from "../../../redux/selectors";

// providers
import {showToastCustom} from "../../../components/toast/customToast";
import {productService} from "../../../jwt/_services/promotions/productService";
import {udnProvider} from "../../../providers/udnProvider";
import {typeProductProvider} from "../../../providers/typeProductProvider";
import {categoryProductProvider} from "../../../providers/categoryProductProvider";
import ProductLangs from "./_langs";

const ProductForm = props => {
    const path = props?.path ;
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { app, editMode, domainObject} = componentState?.data;

    const fbDataBase = {id: app?.fbDataBase?.id}

    const [status, setStatus] = useState(domainObject?.status || true);
    const [paramT, setParamT] = useState(domainObject?.paramT || false);
    const [paramP, setParamP] = useState(domainObject?.paramP || false);
    const [paramC, setParamC] = useState(domainObject?.paramC || false);
    const [paramD, setParamD] = useState(domainObject?.paramD || false);
    const [baseProduct, setBaseProduct] = useState(domainObject?.baseProduct || false);
    const [includeInfants, setIncludeInfants] = useState(domainObject?.includeInfants || false);
    const [includeFood, setIncludeFood] = useState(domainObject?.includeFood || false);

    const [langs, setlangs] = useState(domainObject?.langs || []);
    const translatableLangs = domainObject?.translatedLangs || []

    const [typeProductId, setTypeProductId] = useState(  domainObject?.typeProduct?.id || null);
    const [categoryProductId, setCategoryProductId] = useState(  domainObject?.categoryProduct?.id || null);
    const [udnId, setUdnId] = useState( domainObject?.udn?.id || null);


    const [showModal, setShowModal] = useState(false)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        sivexId: Yup.string().required( REQUIRED ),
        sivexCode: Yup.string().required( REQUIRED ),
    });


    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id:  domainObject?.id ,
            uid:  domainObject?.uid ,
            sivexCode: domainObject?.sivexCode,
            sivexId: domainObject?.sivexId,
            codeLanding: domainObject?.codeLanding,
            showOrder: domainObject?.showOrder,
            imgDefault: domainObject?.imgDefault,
            versionAndroid : domainObject?.versionAndroid,
            versionIos : domainObject?.versionIos,
            componentId : domainObject?.componentId
        }
    });


    const onSubmit = (data, _) => {
        if (typeProductId == null || categoryProductId == null || udnId == null) {
            return showToastCustom(error, selectOption);
        }

        const dataRequest = {
            fbDataBase:  fbDataBase,
            item: {
                ...data,

                // Boleanos
                status: status ,
                paramT: paramT ,
                paramP: paramP,
                paramC: paramC ,
                paramD: paramD,
                baseProduct: baseProduct ,
                includeInfants: includeInfants ,
                includeFood: includeFood ,
                // Objetos
                langs : langs,

                typeProduct: { id : typeProductId },
                categoryProduct: { id : categoryProductId },
                udn: { id : udnId }
            }
        }

        if (!editMode)
            genericIndexedActions.save(path, productService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, productService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.onClose()
    }


    return  <>
        <Card className={'card-big-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <>
                    <h2 className={'card-modal-title'} > { (domainObject?.description || '') }</h2>
                    <br />
                    <h5 className={'card-modal-uid'} > { '     uid: ' + (domainObject?.uid || '') }</h5>
                </>
                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        onClick={handleSubmit(onSubmit)}
                    />
                    {
                        editMode && <>
                            <GenericButton
                                style={'table'}
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Row>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>{FL_SIVEX_CODE}</Label>
                                        <Input type="text" name="sivexCode"
                                               placeholder={PH_SIVEX_CODE}
                                               innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>{FL_SIVEX_ID}</Label>
                                        <Input type="number" name="sivexId"
                                               placeholder={PH_SIVEX_ID}
                                               innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>{FL_LANDING_CODE}</Label>
                                        <Input type="text" name="codeLanding"
                                               placeholder={PH_LANDING_CODE}
                                               innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>{FL_ORDER}</Label>
                                        <Input type="number" name="showOrder"
                                               innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>{FL_IMAGE}</Label>
                                        <Input type="text" name="imgDefault"
                                               placeholder={PH_IMAGE}
                                               innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>{FL_STATUS}</Label>
                                        <br/>
                                        <Switch
                                            animate={true}
                                            offText={"No"}
                                            onText={"Si"}
                                            value={status}
                                            onChange={() => setStatus(!status)}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>{FL_PARAM_T}</Label>
                                        <br/>
                                        <Switch
                                            animate={true}
                                            offText={"No"}
                                            onText={"Si"}
                                            value={paramT}
                                            onChange={() => setParamT(!paramT)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>{FL_PARAM_P}</Label>
                                        <br/>
                                        <Switch
                                            animate={true}
                                            offText={"No"}
                                            onText={"Si"}
                                            value={paramP}
                                            onChange={() => setParamP(!paramP)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>{FL_PARAM_C}</Label>
                                        <br/>
                                        <Switch
                                            animate={true}
                                            offText={"No"}
                                            onText={"Si"}
                                            value={paramC}
                                            onChange={() => setParamC(!paramC)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>{FL_PARAM_D}</Label>
                                        <br/>
                                        <Switch
                                            animate={true}
                                            offText={"No"}
                                            onText={"Si"}
                                            value={paramD}
                                            onChange={() => setParamD(!paramD)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>{FL_IS_BASE_PRODUCT}</Label>
                                        <br/>
                                        <Switch
                                            animate={true}
                                            offText={"No"}
                                            onText={"Si"}
                                            value={baseProduct}
                                            onChange={() => setBaseProduct(!baseProduct)}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>{FL_INCLUDE_FOOD}</Label>
                                        <br/>
                                        <Switch
                                            animate={true}
                                            offText={"No"}
                                            onText={"Si"}
                                            value={includeFood}
                                            onChange={() => setIncludeFood(!includeFood)}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>{'Unidad de negocio'}</Label>
                                        <br/>
                                        <SelectGeneric
                                            initialValue={udnId}
                                            setExternalValue={setUdnId}
                                            provider={udnProvider}

                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>{FL_TIPO_PROD}</Label>
                                        <br/>
                                        <SelectGeneric
                                            initialValue={typeProductId}
                                            setExternalValue={setTypeProductId}
                                            provider={typeProductProvider}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>{FL_CAT_PROD}</Label>
                                        <br/>
                                        <SelectGeneric
                                            initialValue={categoryProductId}
                                            setExternalValue={setCategoryProductId}
                                            provider={categoryProductProvider}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>{FL_COMPONENT_ID}</Label>
                                        <Input type="text"
                                               name="componentId"
                                               innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>{FL_VERSION_ANDROID}</Label>
                                        <Input
                                            type="text"
                                            name="versionAndroid"
                                            innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>{FL_VERSION_IOS}</Label>
                                        <Input
                                            type="text"
                                            name="versionIos"
                                            placeholder={PH_VERSION_IOS}
                                            innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>

                                <Col md="3">
                                    <FormGroup>
                                        <Label>{FL_INCLUDE_INFANTS}</Label>
                                        <br/>
                                        <Switch animate={true}
                                                offText={"No"}
                                                nText={"Si"}
                                                value={includeInfants}
                                                onChange={() => setIncludeInfants(!includeInfants)}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                        <div className={'form-container'}>
                            <div className={''}>
                                <h2>{INTERNATIONAL}</h2>
                            </div>
                            <div className={''}>
                                <ProductLangs
                                    langs={langs}
                                    setLangs={setlangs}
                                    translatableLangs={translatableLangs}
                                    appCode={app.code}
                                />
                            </div>
                        </div>
                    </Col>
                    {/*{*/}
                    {/*    editMode && <Col>*/}
                    {/*        <SausersSection path={path} showHeader={true} onUpdateMenuCategories={onUpdateMenuCategories}/>*/}
                    {/*    </Col>*/}
                    {/*}*/}
                </Row>
            </CardBody>
        </Card>
        {
            showModal && <LogHistoryModal
                ref={modalRef}
                item={domainObject}
            />
        }
    </>
}
export default ProductForm